import React, { useMemo } from "react";
import { ActivationCongratulationsDialogView } from "./activation-congratulations-dialog-view";
import {
  buildPreloadedSimCongratulationsRows,
  type PreloadedSimCongratulationsDetails,
} from "./preloaded-sim-flow";
import { usePreloadedSimCongratulationsContinue } from "./use-preloaded-sim-congratulations-continue";

interface Props {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  details: PreloadedSimCongratulationsDetails;
  nextPath?: string;
  onContinue?: () => void | Promise<void>;
}

export const PreloadedSimCongratulationsDialog = ({
  showDialog,
  setShowDialog,
  details,
  nextPath,
  onContinue: onContinueOverride,
}: Props) => {
  const rows = useMemo(
    () => buildPreloadedSimCongratulationsRows(details),
    [details]
  );

  const { handleContinue: handleContinueDefault } =
    usePreloadedSimCongratulationsContinue({
      showDialog,
      setShowDialog,
      nextPath,
    });

  const handleContinue = onContinueOverride ?? handleContinueDefault;

  return (
    <ActivationCongratulationsDialogView
      showDialog={showDialog}
      setShowDialog={setShowDialog}
      description="Your devices are compatible for VLE Mobile services."
      rows={rows}
      onContinue={handleContinue}
    />
  );
};
